(function() {
  angular.module('forgotPassword')
    .controller('passwordResetLinkSentController', ['$scope', '$q', 'loginUserService', '$log', '$state', '$filter', '$translate',
      function ($scope, $q, loginUserService, $log, $state, $filter, $translate) {
        var vm = this;
        vm.model = loginUserService.loginModel();
        vm.maskedEmail = $filter('maskEmail')(vm.model.email);

        if (!vm.model.userIdentified) {
          $state.go('forgotPassword',{userId: vm.model.userId});
        }

        $translate('content.forgotPassword.contactInfo').then((contactInfo) => {
          $translate('content.forgotPassword.passwordResetLinkSent',{
            contactInfo: contactInfo,
            email: vm.maskedEmail
          }).then((text) => {
            vm.confirmPasswordResetText = text;
          });
        });

      }]);
})();
